/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiRerunScenariosForTransactionsByCreatedTimeRangeRequest
 */
export interface InternalApiRerunScenariosForTransactionsByCreatedTimeRangeRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalApiRerunScenariosForTransactionsByCreatedTimeRangeRequest
     */
    scenarioHandles: Array<string>;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiRerunScenariosForTransactionsByCreatedTimeRangeRequest
     */
    createdFrom: Date;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiRerunScenariosForTransactionsByCreatedTimeRangeRequest
     */
    createdTo: Date;
}

/**
 * Check if a given object implements the InternalApiRerunScenariosForTransactionsByCreatedTimeRangeRequest interface.
 */
export function instanceOfInternalApiRerunScenariosForTransactionsByCreatedTimeRangeRequest(value: object): value is InternalApiRerunScenariosForTransactionsByCreatedTimeRangeRequest {
    if (!('scenarioHandles' in value) || value['scenarioHandles'] === undefined) return false;
    if (!('createdFrom' in value) || value['createdFrom'] === undefined) return false;
    if (!('createdTo' in value) || value['createdTo'] === undefined) return false;
    return true;
}

export function InternalApiRerunScenariosForTransactionsByCreatedTimeRangeRequestFromJSON(json: any): InternalApiRerunScenariosForTransactionsByCreatedTimeRangeRequest {
    return InternalApiRerunScenariosForTransactionsByCreatedTimeRangeRequestFromJSONTyped(json, false);
}

export function InternalApiRerunScenariosForTransactionsByCreatedTimeRangeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiRerunScenariosForTransactionsByCreatedTimeRangeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'scenarioHandles': json['scenarioHandles'],
        'createdFrom': (new Date(json['createdFrom'])),
        'createdTo': (new Date(json['createdTo'])),
    };
}

export function InternalApiRerunScenariosForTransactionsByCreatedTimeRangeRequestToJSON(json: any): InternalApiRerunScenariosForTransactionsByCreatedTimeRangeRequest {
    return InternalApiRerunScenariosForTransactionsByCreatedTimeRangeRequestToJSONTyped(json, false);
}

export function InternalApiRerunScenariosForTransactionsByCreatedTimeRangeRequestToJSONTyped(value?: InternalApiRerunScenariosForTransactionsByCreatedTimeRangeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'scenarioHandles': value['scenarioHandles'],
        'createdFrom': value['createdFrom'].toISOString(),
        'createdTo': value['createdTo'].toISOString(),
    };
}

